import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const trainAddrDetailInfo = async (params: object) => {
  return await GET({ url: Api.trainAddrDetailInfo, params, showError: false })
}
